import React from 'react';
import { Button, Typography } from 'antd';
import { CloseOutlined, FileTextOutlined, FilePdfOutlined, FileWordOutlined } from '@ant-design/icons';

const { Paragraph } = Typography;

export default function FileAttached({ fileName, onRemove }) {
  const getFileIcon = (fileName) => {
    const extension = fileName.split('.').pop().toLowerCase();
    switch (extension) {
      case 'pdf':
        return <FilePdfOutlined style={{ fontSize: 30, color: '#1890ff' }} />;
      case 'docx':
        return <FileWordOutlined style={{ fontSize: 30, color: '#1890ff' }} />;
      default:
        return <FileTextOutlined style={{ fontSize: 30, color: '#1890ff' }} />;
    }
  };

  return (
    <>
      <div style={{ position: 'relative', display: 'inline-block', marginTop: 0 }}>
        {getFileIcon(fileName)}
        <Button 
          type="text" 
          icon={<CloseOutlined style={{ fontSize: 12, color: 'gray' }} />}
          style={{ 
            color: 'gray', 
            padding: 0,
            position: 'absolute',
            top: -15,
            right: -12,
            background: 'white',
            borderRadius: '50%',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            width: 22,
            height: 22,
            minWidth: 20,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
          onClick={(e) => {
            e.stopPropagation();
            onRemove();
          }}
        />
      </div>
      <Paragraph type="secondary" style={{ marginTop: 10, marginBottom: 0 }}>
        {fileName}
      </Paragraph>
    </>
  );
} 